import React, { useState, useEffect } from 'react'
import { useTranslation } from '../hooks/useTranslation'

export const validatePhone = (rawValue) => {
  const normalized = (rawValue || '').replace(/\D/g, '')
  const isValid = normalized.length >= 10
  return {
    isValid,
    normalized,
    error: isValid ? '' : 'Lütfen SMS Gönderdiğimiz Kişisel Cep Numaranızı Giriniz.'
  }
}

const PhoneAccess = ({
  value,
  onChange,
  error,
  onErrorChange,
  autoFocus = false,
  placeholder,
  label
}) => {
  const { t } = useTranslation()
  const [internalValue, setInternalValue] = useState(value || '')
  const [internalError, setInternalError] = useState('')

  useEffect(() => {
    setInternalValue(value || '')
  }, [value])

  const handleChange = (e) => {
    const next = e.target.value
    setInternalValue(next)
    if (onChange) onChange(next)
  }

  const handleBlur = () => {
    const { isValid, error: err } = validatePhone(internalValue)
    if (!isValid) {
      setInternalError(err)
      if (onErrorChange) onErrorChange(err)
    } else {
      setInternalError('')
      if (onErrorChange) onErrorChange('')
    }
  }

  const shownError = (error !== undefined ? error : internalError) || ''

  return (
    <div className="phone-input-container">
      <label style={{ display: 'block', marginBottom: 6, color: "white",fontSize: "16px" }}>
        {label || t('labels.phone', 'Telefon Numarası')}
      </label>
      <input
        type="tel"
        value={internalValue}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder || t('placeholders.phone', '90 5xx xxx xx xx')}
        className="phone-input"
        autoFocus={autoFocus}
        style={{
          width: '100%',
          padding: '10px 12px',
          borderRadius: 8,
          border: shownError ? '1px solid #ff4757' : '1px solid #ddd',
          outline: 'none',
          marginTop: 8
        }}
      />
      {shownError && (
        <div style={{ color: '#ff4757', fontSize: 18, marginTop: 6 }}>{shownError}</div>
      )}
    </div>
  )
}

export default PhoneAccess